import { render, staticRenderFns } from "./yibaoDialog.vue?vue&type=template&id=71e1173f&scoped=true"
import script from "./yibaoDialog.vue?vue&type=script&lang=js"
export * from "./yibaoDialog.vue?vue&type=script&lang=js"
import style0 from "./yibaoDialog.vue?vue&type=style&index=0&id=71e1173f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e1173f",
  null
  
)

export default component.exports